import {
  ISettingTemplateForm,
  ISettingTemplatePayload,
  ICriteria,
  ISettingTemplate,
  ICriteriaUsageVariable,
} from '~/connect/types';

export function fromFormToPayload(
  data: ISettingTemplateForm,
  criteria: ICriteria[],
): ISettingTemplatePayload {
  return {
    ...data,
    criteria: data.criteria.map(({ criterion, values }) => ({
      criterion,
      values:
        criteria
          .find((criteria) => criteria.id === criterion.id)
          ?.values.filter((value) =>
            values.some((selectedValueId) => selectedValueId === value.id),
          ) ?? [],
    })),
  };
}

export function toFormData(
  settingTemplate: ISettingTemplate,
): ISettingTemplateForm {
  return {
    ...settingTemplate,
    criteria: settingTemplate.criteria.map(({ criterion, values }) => ({
      criterion,
      values: values.map((value) => value.id),
    })),
  };
}

export function fromFormToQuery(
  id: string,
  data: ISettingTemplatePayload,
): ICriteriaUsageVariable {
  return {
    id: id,
    query: {
      criteria: data.criteria.map(({ criterion, values }) => ({
        criterion: criterion.id,
        values: values.map((v) => v.id),
      })),
    },
  };
}

export const SETTING_TEMPLATE_FORM_DEFAULT_VALUES: ISettingTemplateForm = {
  name: '',
  criteria: [],
  alternativeOfferSetting: {
    j0: false,
    j0Today: false,
    j0NextDay: false,
    bestDelay: false,
    bestPrice: false,
  },
  generalSetting: {
    backOrder: false,
    alternativeReferenceEnabled: false,
    referenceGroupPublicKey: null,
    alternativeSupplierPriceFrameType: '',
    wholesalerSupplierPriceFrameType: 'BF_OFFICIAL',
    tyreIdentifierFields: [],
    displayBestPriceTag: false,
    displayBestDelayTag: false,
    manualSearch: false,
    defaultSeasons: [],
    defaultHomologations: [],
    defaultWidthMin: 175,
    defaultWidthMax: 345,
    destockingEnabled: false,
  },
  vehicleTypeGroups: [],
};
